import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Button, Card, Tabs, Modal, message } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { deleteMatchDay, getGroupMatchDays, getGroups } from 'api/events';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { JornadasModal } from 'componentsv2/util-components/JornadasModal/JornadasModal';
import JornadasList from 'componentsv2/Jornadas';
import BlockPageLoader from 'components/Loaders/BlockPageLoader';
import useNetworkState from 'hooks/useNetworkState';

const JornadasMain = ({ history, match }) => {
  const { TabPane } = Tabs;
  const { groupId } = useParams();
  const [rounds, setRounds] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [loadingGroupRounds, setLoadingGroupRounds] = useState(true);
  const loading = useMemo(() => loadingGroupRounds, [loadingGroupRounds]);
  const backgroundFetchNetworkState = useNetworkState();

  const resolver = useCallback(
    async (key, _eventId) => {
      backgroundFetchNetworkState.setIsLoading();
      const { body } = await getGroups(_eventId);
      backgroundFetchNetworkState.setDoneLoading();

      return body?.data?.groups || [];
    },
    [backgroundFetchNetworkState],
  );

  const { data } = useQuery(['event-groups', match?.params?.eventId], resolver);
  const groups = useMemo(() => data || [], [data]);
  const currentGroup = useMemo(() => {
    return groups?.find(group => Number(group.id) === Number(groupId));
  }, [groupId, groups]);

  const onLoadRounds = useCallback(() => {
    setLoadingGroupRounds(true);

    getGroupMatchDays(groupId)
      .then(({ body, status }) => {
        if ([200, 201].includes(status)) {
          setRounds(body?.data?.rounds || []);
        }

        setLoadingGroupRounds(false);
      })
      .catch(() => {
        setLoadingGroupRounds(false);
      });
  }, [groupId]);

  const handleDeleteJornada = async (jornadaId, jornadaTitle) => {
    Modal.confirm({
      title: 'Confirmar eliminación',
      icon: <ExclamationCircleOutlined />,
      content: `¿Estás seguro de eliminar ${jornadaTitle}?`,
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      async onOk() {
        try {
          message.loading('Eliminando Jornada...', 1);
          await deleteMatchDay(match?.params?.eventId, currentGroup.id, jornadaId);
          message.success('!Jornada eliminada con éxito!');
          onLoadRounds();
          setActiveTab(1);
        } catch (error) {
          message.error('!Ha ocurrido un error!');
        }
      },
    });
  };

  useEffect(() => {
    onLoadRounds();
  }, [groupId, onLoadRounds]);

  if (loading) {
    return <BlockPageLoader className="min-h-screen" valignTop />;
  }

  return (
    <Card
      title={
        <>
          Jornadas - Grupo {currentGroup?.name}
          <Button
            type="primary"
            style={{ marginLeft: '10px', padding: '0 0.5rem', height: '1.5rem' }}
            onClick={() => setIsModalVisible(true)}
          >
            Administrar
          </Button>
        </>
      }
    >
      <JornadasModal
        isVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        tournamentId={match?.params?.eventId}
        groupId={currentGroup?.id}
        onLoadRounds={onLoadRounds}
      />
      <Tabs
        defaultActiveKey={activeTab}
        onChange={key => {
          setActiveTab(key);
        }}
      >
        {rounds?.map((round, index) => {
          return (
            <TabPane tab={round?.title} key={index + 1}>
              <div key={round?.id}>
                <div
                  style={{
                    marginTop: '20px',
                    fontSize: '26px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  className="avatar-status-name"
                >
                  {round?.title}
                  <Button
                    danger
                    type="primary"
                    style={{ position: 'absolute', right: '1.25rem' }}
                    onClick={() => handleDeleteJornada(round?.id, round?.title)}
                  >
                    Eliminar
                  </Button>
                </div>
                {round?.matches.map(match => {
                  return (
                    <JornadasList
                      onLoadRounds={onLoadRounds}
                      matchDayId={round?.id}
                      key={match?.id}
                      match={match}
                      isEdit={false}
                    />
                  );
                })}
              </div>
            </TabPane>
          );
        })}
      </Tabs>
    </Card>
  );
};

export default JornadasMain;
